import { RowCellContent, Table, TableBody } from "@dash/table";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom-v5-compat";

import { Account } from "@megaron/cash-rewards-contracts";

type Props = {
  accounts: Account[];
};

const tableHeadingList = [
  { heading: "Użytkownik" },
  { heading: "Saldo" },
];

export const AccountsTable: React.FC<Props> = ({ accounts }) => {
  const theme = useTheme();

  const tableColumns = [
    {},
    ...tableHeadingList.map(
      ({ heading }) =>
        ({
          isSortable: false,
          label: heading,
        } as const),
    ),
  ];

  const handleRowClick = (userId: string) => {
    window.location.href = `/specjalista/accounts/id/${userId}`;
  };

  const getTableRowCellsContent = (account: Account): RowCellContent[] => {
    return [
      {
        isLink: false,
        element: <div css={{ display: "flex", alignItems: "center", gap: 4 }} />,
      },
      {
        isLink: true,
        element: (
          <Link
            to={`/specjalista/accounts/id/${account.userId}`}
            css={{
              color: theme.colors.primary,
              textDecoration: "underline",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {account.userId}
          </Link>
        ),
      },
      {
        isLink: false,
        element: (
          <div
            css={{
              fontWeight: account.balance && account.balance.greaterThan(0) ? 600 : 400,
            }}
          >
            {account.balance.toString()}
          </div>
        ),
      },
    ];
  };

  return (
    <Table columns={tableColumns}>
      <TableBody
        rows={accounts.map((account) => ({
          uuid: account.userId,
          cellsContent: getTableRowCellsContent(account),
          onClick: () => handleRowClick(account.userId),
          css: {
            cursor: "pointer",
          },
        }))}
      />
    </Table>
  );
};
